import React from 'react';

const MaintenanceScreen = ({ logoSrc }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 px-4" data-testid="maintenance-screen">
      <div className="text-center max-w-md w-full">
        <div className="w-28 h-28 mx-auto mb-6 rounded-2xl overflow-hidden bg-white shadow-sm flex items-center justify-center" data-testid="maintenance-logo">
          <img src={logoSrc} alt="MATE" className="w-full h-full object-contain" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        </div>
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-5">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-amber-600"><path d="M12 9v4"/><path d="M12 17h.01"/><path d="M2.5 17a2 2 0 0 1-.2-2.8l8.3-10.4a2 2 0 0 1 3.1 0l8.3 10.4a2 2 0 0 1-.2 2.8H2.5Z"/></svg>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">Sistema en Mantenimiento</h1>
        <p className="text-slate-600 mb-6">Estamos realizando mejoras en la plataforma. Por favor, intente nuevamente en unos minutos.</p>
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-2.5 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors font-medium"
          data-testid="maintenance-retry"
        >
          Reintentar
        </button>
      </div>
    </div>
  );
};

export default MaintenanceScreen;
